import React, { Fragment } from "react";
import _ from "lodash";
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogTitle, Grid, FormHelperText} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {AutoCompleteInput, DatePicker, IntegerInput} from 'components/Global/FastFormikMaterial';
import Dropdown from 'components/Global/Dropdown/Dropdown';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import {
  NoPenalty, 
  Lockout,
  Defeasance,
  AggregateInterest,
  FlatPercentage,
  MakeWhole,
  SpreadMaintenance,
  YieldMaintenanceAgency,
  YieldMaintenance} from './PrepaymentScheduleModalFormVariants'
import {
  prepaymentTypes,
  NONE,
  YIELD_MAINTENANCE,
  MAKE_WHOLE,
  FLAT_PERCENTAGE,
  DEFEASANCE,
  LOCKOUT,
  YIELD_MAINTENANCE_AGENCY,
  AGGREGATE_INTEREST,
  SPREAD_MAINTENANCE} from 'constants/prepaymentTypes';
let prepaymentTypeList = prepaymentTypes.map( x=> {
  if(x.value === NONE){
    return {
      name: 'No Penalty',
      value: x.value
    }
  }
  return x;
})
const FormGrid = styled.div`
  padding:0 20px 20px 20px;
`
const VerticalSpace = styled.div`
  height:32px;
  width:100%;
`
const ButtonWrapperGrid = styled(Grid)`
  margin-top:16px;
`
const FullHeight = styled.div`
  min-height:400px;
`
const StyledDropdown = styled(Dropdown)`
  margin-top:16px;
`
const StyledDatePicker = styled(DatePicker)`
  width:100%;
`
const Error = styled.div`
  color:red;
`
const styles = theme => ({
  dialogPaper: {
    'max-width':'600px',
    'font-size': '13px',        
  },
  dialogTitle: {    
    padding: '8px 0 0 20px'
  }
})

const ErrorMessage = ({message}) => (
  <Error>{message}</Error>
)

class PrepaymentScheduleModalForm extends React.Component {
  state ={
    hasErrors:false,
    errorMessage: ''
  }
  onCancel = () => {
    this.props.onClose();
  }
  closeModal = () => {
    this.props.onClose();  
  };   

  renderNoPenalty = () => {
    const {index} = this.props;
    const {begin:startDate, end:endDate} = this.getFields(['begin','end']);    
    return (
    <NoPenalty 
      index={index}
      setDescription={this.setDescription}
      startDate={startDate} endDate={endDate}/>)
  }
  renderYieldMaintenance = () => {
    const {index} = this.props;
    const {openPeriod, percent,replacementRateSpread} = this.getFields(['openPeriod','percent','replacementRateSpread']);    
    return (
    <YieldMaintenance
      setDescription={this.setDescription}
      index={index}
      openPeriod={openPeriod}
      percent={percent}
      replacementRateSpread={replacementRateSpread}/>)
  }
  renderYieldMaintenanceAgency = () => {
    const {index} = this.props;
    const {openPeriod, percent,replacementRateSpread} = this.getFields(['openPeriod','percent','replacementRateSpread']);    
    return (
    <YieldMaintenanceAgency
      setDescription={this.setDescription}
      index={index}
      openPeriod={openPeriod}
      percent={percent}
      replacementRateSpread={replacementRateSpread}/>)
  }
  renderMakeWhole = () => {
    const {index} = this.props;
    const {openPeriod, percent,replacementRateSpread} = this.getFields(['openPeriod','percent','replacementRateSpread']);    
    return (
    <MakeWhole
      setDescription={this.setDescription}
      index={index}
      openPeriod={openPeriod}
      percent={percent}
      replacementRateSpread={replacementRateSpread}/>)
  }
  renderFlatPercentage = () => {
    const {index} = this.props;
    const { percent} = this.getFields(['percent']);    
    return (
    <FlatPercentage
      setDescription={this.setDescription}
      index={index}
      percent={percent}/>)
  }
  renderDefeasance = () => {
    const {index} = this.props;
    const { openPeriod} = this.getFields(['openPeriod']);    
    return (
    <Defeasance
      setDescription={this.setDescription}
      index={index}
      openPeriod={openPeriod}/>)
  }
  renderSpreadMaintenance = () => {
    const {index} = this.props;
    const { openPeriod} = this.getFields(['openPeriod']);    
    return (
    <SpreadMaintenance
      setDescription={this.setDescription}
      index={index}
      openPeriod={openPeriod}/>)
  }
  renderAggregateInterest = () => {    
    const {index} = this.props;
    const { aggregateInterestMethodId, aggregateInterestDefinedAmt,aggregateInterestMonthsOfInterest} = this.getFields(
        ['aggregateInterestMethodId', 'aggregateInterestDefinedAmt', 'aggregateInterestMonthsOfInterest']);    
    return (
    <AggregateInterest
      setDescription={this.setDescription}
      index={index}
      aggregateInterestMethodId={aggregateInterestMethodId}
      aggregateInterestDefinedAmt={aggregateInterestDefinedAmt}
      aggregateInterestMonthsOfInterest={aggregateInterestMonthsOfInterest}
      />
    )
  }
  renderLockout = () => {
    const {index} = this.props;
    const {begin:startDate, end:endDate} = this.getFields(['begin','end']);    
    return (
    <Lockout 
      index={index}
      setDescription={this.setDescription}
      startDate={startDate} endDate={endDate}/>)
  }  
  getFields = (fields) => {
    const {formik,index} = this.props;
    const {values} = formik;
    const foundValues = {};
    for(let i = 0; i < fields.length;i++){
      let field = fields[i];
      let val = _.get(values, `prepaymentSchedules[${index}].${field}`);    
      foundValues[field] = val;
    }        
    return foundValues;
  }
  renderBasedOnPrepaymentType = (prepaymentTypeId) => {
    switch(prepaymentTypeId){
      case NONE:
        return this.renderNoPenalty();
      case YIELD_MAINTENANCE:
        return this.renderYieldMaintenance();
      case MAKE_WHOLE:
        return this.renderMakeWhole();
      case FLAT_PERCENTAGE:
        return this.renderFlatPercentage();
      case DEFEASANCE:
        return this.renderDefeasance();
      case LOCKOUT:
        return this.renderLockout();
      case YIELD_MAINTENANCE_AGENCY:
        return this.renderYieldMaintenanceAgency();
      case AGGREGATE_INTEREST:
        return this.renderAggregateInterest();
      case SPREAD_MAINTENANCE:
        return this.renderSpreadMaintenance();
    }
  }
  setDescription = (description) => {
    const {formik, index} = this.props;
    formik.setFieldValue(`prepaymentSchedules[${index}].description`, description);    
  }
  render() {
    const {classes, isOpen,index,formik,isQuote} = this.props;
    const hasErrors = false;
    const errorMessage = "";    
    const {values} = formik;    
    const prepaymentTypeId = _.get(values, `prepaymentSchedules[${index}].prepaymentTypeId`);
    let activeItem = _.get(values, `prepaymentSchedules[${index}]`);
    if(!activeItem) activeItem = {};
    if(!activeItem.begin && !isQuote) {
      let beginPrefill = null;
      if(index <= 0) beginPrefill = this.props.loanDetails.details.closingDate;
      else {
        let precedingItem = _.get(values, `prepaymentSchedules[${index-1}]`);
        let precedingEndDate = new Date(precedingItem.end);
        precedingEndDate.setDate(precedingEndDate.getDate() + 1);
        beginPrefill = precedingEndDate
      }
      activeItem.begin = beginPrefill;
    }
    if(!activeItem.term && isQuote){
      let termPrefill = null;
      if(index <= 0) termPrefill = this.props.loanDetails.details.loanTermMonths;
      else {
        let cumulativeTerm = 0;
        for(let i = 0; i < index; i++){
          let precedingTerm =  parseInt(_.get(values, `prepaymentSchedules[${i}]`).term) || 0;
          cumulativeTerm += precedingTerm;
        }
        termPrefill = this.props.loanDetails.details.loanTermMonths - cumulativeTerm;
      }
      activeItem.term = termPrefill >= 0 ? termPrefill : 0;
    }
    if(!activeItem.end && !isQuote) activeItem.end = this.props.loanDetails.details.maturityDate;
    return (
      <Fragment>        
        <Dialog open={isOpen} 
          id="prepaymentScheduleModel"
          onClose={this.closeModal} 
          fullWidth 
          maxWidth="md" 
          classes={{paper: classes.dialogPaper}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <DialogTitle classes={{root: classes.dialogTitle}}>Prepayment Schedule</DialogTitle>
            <IconButton style={{ marginRight: 8,marginTop:8 }} onClick={this.closeModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <FormGrid>
          <FullHeight>
            <Grid container alignContent="space-between">
              <Grid item xs={9}>
                <AutoCompleteInput 
                  formik={formik}
                  label="Select Prepayment Type"
                  id="dropdownForPrepaymentScheduleType"
                  fieldName={`prepaymentSchedules[${index}].prepaymentTypeId`}
                  options={prepaymentTypeList}
                  selectName='name'
                  selectValue='value'/>
              </Grid>
              <Grid item></Grid>
              <VerticalSpace/>
              {!isQuote && <>
              <Grid item xs={4}>
                <StyledDatePicker
                  id="prepaymentScheduleStartDateField"
                  label="Start Date"
                  defaultValue={new Date()}
                  fieldName={`prepaymentSchedules[${index}].begin`}/>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={4}>
                <StyledDatePicker
                id="prepaymentScheduleEndDateField"
                  label="End Date"
                  fieldName={`prepaymentSchedules[${index}].end`}/>
              </Grid>
              </>}
              {isQuote && 
              <Grid item xs={4}>
              <IntegerInput
              id="prepaymentScheduleTermField"
                label="Term (m)"
                fieldName={`prepaymentSchedules[${index}].term`}/>
            </Grid>}
              <VerticalSpace/>
             {this.renderBasedOnPrepaymentType(prepaymentTypeId)}
             </Grid>
          </FullHeight>
            <ButtonWrapperGrid container direction="row" justify="flex-end">
              {hasErrors && <ErrorMessage message={errorMessage}/>}
              <SecondaryButton id="prepaymentScheduleModelCancelButton" onClick={this.onCancel}>Cancel</SecondaryButton>
              <PrimaryButton id="prepaymentScheduleModelAddButton" onClick={() => this.props.onEdit()}>{this.props.isAdding ? 'Add' : 'Save'}</PrimaryButton>
            </ButtonWrapperGrid>
          </FormGrid>
        </Dialog>
      </Fragment>
    );
  }
}

function mapStateToProps({loanDetails}) {
  return {
    loanDetails: loanDetails.loanDetails,
  };
}


export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
      
    }
  ),
  withStyles(styles)
)(PrepaymentScheduleModalForm);